import { useEffect, useState } from "react";
import NewOccurrenceForm from "../components/form/newOccurrenceForm";
import { OccurrenceStepLabelEnum } from "../../../enums/occurrenceStep";
import { Occurrence } from "../../../models/occurrence";

import "../styles.scss";

interface IFormDialogProps {
    occurrence: Occurrence;
    setOccurrence: (occurrence: Occurrence) => void;
    showDialog: boolean;
    onClose: () => void;
    partners: { id: string, name: string }[];
    create: (occurrence: Occurrence) => Promise<{ wasCreated: boolean, error?: string }>;
    isValidStep: (requiredFields: string[], occurrence: Occurrence) => boolean;
    persona: 'MANAGER' | 'TOWER' | 'CONSULTANT' | 'PARTNERSHIP';
}

const NewOccurrenceFormDialog = (props: IFormDialogProps) => {
    const [occurrence, setOccurrence] = useState<Occurrence | null>(props.occurrence);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setOccurrence({} as Occurrence);
    }, [props.showDialog]);

    const formProps = {
        occurrence: occurrence,
        partners: props.partners,
        setOccurrence: (updatedOccurrence: Partial<Occurrence>) => setOccurrence(prev => ({ ...prev, ...updatedOccurrence } as Occurrence)),
        setOccurrenceValue: (attr: string, value: any) => setOccurrence(prev => ({ ...prev, [attr]: value } as Occurrence)),
        setOccurrenceStepValue: (step: OccurrenceStepLabelEnum, attr: string, value: any) => setOccurrence(prev => ({ ...prev, steps: prev?.steps?.map(stepEl => stepEl.name === step ? { ...stepEl, [attr]: value } : stepEl) ?? [] }) as Occurrence),
        step: {
            id: undefined,
            name: OccurrenceStepLabelEnum.CALL,
            dtStart: new Date(),
            dtEnd: null,
            latest: 0,
        },
        isValidStep: (requiredFields: string[]) => !!(occurrence && props.isValidStep(requiredFields, occurrence)),
        loading,
        save: (occurrence: Occurrence) => { return Promise.resolve(false) },
        create: async (occurrence: Occurrence) => {
            setLoading(true);
            const response = await props.create(occurrence);
            if (response.wasCreated) {
                props.onClose();
                setLoading(false);
                return { wasCreated: true };
            }
            setLoading(false);
            return { wasCreated: false, error: response.error };
        },
        onClose: props.onClose,
        disabledAllFields: false,
        getNotFilledRequiredFields: (requiredFields: string[], occurrence: Occurrence) => {
            return requiredFields.filter(field => !occurrence[field as keyof Occurrence]);
        }
    }
    return (
        props.showDialog && <>
            <div className="bg-kanban-sidebar" onClick={props.onClose}></div>
            <div className="kanban-sidebar">
                <div className="flex justify-between items-center px-6">
                    <div className="text-size-h4 p-4">
                        Novo chamado
                    </div>

                    <div className="p-4 text-size-h5 padding-right-10 cursor-pointer">
                        <span className="rioglyph rioglyph-remove" onClick={props.onClose}></span>
                    </div>
                </div>
                <hr className="border-color-gray-light border-bottom-solid !mb-0" />
                <div className="p-6 overflow-y-auto h-[calc(100vh-70px)]">
                    <NewOccurrenceForm {...formProps} persona={props.persona} />
                </div>
            </div>
        </>
    );
};

export default NewOccurrenceFormDialog;